<template>
  <card class="card-stats" :show-footer-line="true" :body-classes="color">
    <b-row slot="header">

      <b-col>
        <slot>
          <span class="h3 font-weight-bold mb-0" v-if="title">{{title}}</span>
        </slot>
      </b-col>


      <b-col cols="auto" v-if="$slots.icon || icon">
        <slot>
          <span class="h6 font-weight-bold mb-0 mr-1" v-if="cTitle">
            <base-button size="sm"  type="secondary" class="p-1" @click="changeTab(tabId, cTitle)"
                         v-bind:class="btnActivated === cTitle ? 'bg-primary text-white' : ''"
            >{{cTitle}}</base-button>
          </span>
        </slot>
        <slot>
          <span class="h6 font-weight-bold mb-0 mr-1" v-if="dTitle">
            <base-button size="sm" type="secondary" class="p-1" @click="changeTab(tabId, dTitle)"
                         v-bind:class="btnActivated === dTitle ? 'bg-primary text-white' : ''"
            >{{dTitle}}</base-button>
          </span>
        </slot>
        <slot>
          <span class="h6 font-weight-bold mb-0 mr-1" v-if="mTitle">
            <base-button size="sm" type="secondary" class="p-1" @click="changeTab(tabId, mTitle)"
                         v-bind:class="btnActivated === mTitle ? 'bg-primary text-white' : ''">
              {{mTitle}}</base-button>
          </span>
        </slot>
        <slot>
          <span class="h6 font-weight-bold mb-0 mr-1" v-if="yTitle">
            <base-button size="sm" type="secondary" class="p-1" @click="changeTab(tabId, yTitle)"
                         v-bind:class="btnActivated === yTitle ? 'bg-primary text-white' : ''">
              {{yTitle}}</base-button>
          </span>
        </slot>
        <slot name="icon" class="pl-2">
          <div class="icon icon-xs icon-shape mt-1 text-white rounded-circle shadow"
               :class="[`bg-${type}`, iconClasses]">
            <i :class="icon"></i>
          </div>
        </slot>
      </b-col>
    </b-row>

    <p class="mt-1 mb-0 text-sm">
      <slot name="footer">

      </slot>
    </p>
  </card>
</template>
<script>
  import Card from './Card.vue';

  export default {
    name: 'stats-card',
    components: {
      Card
    },
    props: {
      type: {
        type: String,
        default: 'primary'
      },
      tabId: String,
      icon: String,
      title: String,
      cTitle: String,
      dTitle: String,
      mTitle: String,
      yTitle: String,
      iconClasses: [String, Array],
      color: String
    },
    data() {
      return {
        btnActivated: 'Current'
      }
    },
    methods: {
      changeTab(id, title) {
        switch (id) {
          case 'dataSession': {
            this.$emit('changeSessionTab', title);
            this.btnActivated = title;
            break;
          }
          case 'dataVolume': {
            this.$emit('changeVolumeTab', title);
            this.btnActivated = title;
            break;
          }
          case 'alerts': {
            this.$emit('changeAlertsTab', title);
            this.btnActivated = title;
            break;
          }
          case 'zeroSessions': {
            this.$emit('changeZeroSessionsTab', title);
            this.btnActivated = title;
            break;
          }
          default:
            break;
        }

      }
    }
  };
</script>
